import React from 'react'

const Eighteen = () => {
    return (
        <div className='container'>
            <h1>Check whether given number is prime or not?</h1>
              <div className='containers'>
                  <p>In this program a  number is given  by user an we have to check that
                      whether the number is prime or not?
                  </p>
                  <p>
                      Consider N=5; as we know prime number have can oly be divided by
                      1 and itself only  So 5 is a prime number as it only divides by 1 and 5  
                  </p>
              </div>   <div className='containers'>
              <code class="library">#include &lt;stdio.h&gt;</code> <br />
             <code className='keywords'>int</code>  main()<br /> &#123;<br />
 <code className='keywords'> int</code> n, i, c = 0;<br />
 <code className='library'>printf</code>("Enter any number n:");<br />
 <code className='library'>scanf</code>("%d", &n);<br />

   <code className='comment'>/*logic*/</code>  <br />
  <code className='keywords'>for</code> (i = 1; i &lt;= n; i++)<br /> &#123;<br />
  <code className='keywords'>if </code>(n % i == 0)<br /> &#123;<br />
         c++;<br />
      &#125;<br />
  &#125;<br />

  <code className='keywords'>if</code> (c == 2) &#123;<br />
  <code className='library'>printf</code>("n is a Prime number");<br />
  &#125;<br />
  <code className='keywords'>else</code> &#123;<br />
  <code className='library'>printf</code>("n is not a Prime number");<br />
  &#125;<br />
  <code className='library'>return</code>  0;   <br />
&#125;<br />
              </div>
            <h4>Dry Run</h4>
            <div className='line'>
              consider a number n=5 <br />
<b>for(i=0;i&lt;=n;i++)</b> /* for loop is executed until the n value equals i */<br />
<b>i.e. for(i=0;i&lt;=5;i++)</b> /* here the for loop is executed until i is equal to n */<br />
<br />
<b> 1st iteration</b>: i = 1; i &lt;= 5; i++<br />
here i is incremented i.e. i value for next iteration is 2<br />
now if(n%i==0) then c is incremented<br />
i.e.if(5%1==0)then c is incremented, here 5%1=0 thus c is incremented.<br />
now c=1;<br />

<b> 2nd iteration</b>: i = 2; i &lt;= 5; i++<br />
here i is incremented i.e. i value for next iteration is 3<br />
now if(n%i==0) then c is incremented<br />
i.e.if(5%2==0) then c is incremented, but 5%2!=0 and so c is not incremented, c remains 1<br />
c=1;<br />

<b>3rd iteration</b>: i = 3; i &lt;= 5; i++<br />
here i is incremented i.e. i value for next iteration is 4<br />
now if(n%i==0) then c is incremented<br />
i.e.if(5%3==0) then c ic incremented, but 5%3!=0 and so c is not incremented, c remains 1<br />
c=1;<br />

<b>4th iteration</b>: i = 4; i &lt;= 5; i++<br />
here i is incremented i.e. i value for next iteration is 5<br />
now if(n%i==0) then c is incremented<br />
i.e. if(5%4==0) then c is incremented, but 5%4!=0 and so c is not incremented, c remains 1<br />
c=1;<br />

<b>5th iteration</b>: i = 5; i &lt;= 5; i++<br />
here i is incremented i.e. i value for next iteration is 6<br />
now if(n%i==0) then c is incremented<br />
i.e. if(5%5==0) then c is incremented, 5%5=0 and so c is incremented.<br />
i.e. c=2<br />

<b>6th iteration</b>: i = 6; i &lt;= 5; i++<br />
here i value is 6 and 6&lt;=5 is false thus the condition fails and control leaves the for loop.<br />
now if(c==2) then n is a prime number<br />
we have c=2 from the 5th iteration and thus n=5 is a Prime number.<br />
</div>
           
        </div>
    )
}

export default Eighteen
